// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1YmYD","inner":"Form_inner__16KDB","range":"Form_range__3h8kd","name":"Form_name__2YhWh","actions":"Form_actions__1xoUk"};